export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7104.d650fdf8.jpg";